/** 時刻、日付に関するメソッドをまとめるクラス */
export class UtilCalcTime {

  /** string型をDate型(時刻未指定)に変換してreturn
  * @param {string} dateStr 日付文字列（yyyy-MM-dd, yyyy/MM/dd)
  * @param {string} splitStr 区切り文字（"-", "/"など）
  */
  toDate (dateStr: string, splitStr: string): Date {
    if (dateStr === null) {
      return null;
    }
    const array: string[] = dateStr.split(splitStr);
    return new Date(Number(array[0]), Number(array[1]) - 1, Number(array[2]));
  }
    /** string型をDate型(時刻指定)に変換してreturn
  * @param {string} dateStr 日付文字列（yyyy/MM/dd HH24:MI:SS)
  */
  toDateTime (dateStr: string): Date {
    if (dateStr === null) {
      return null;
    }
    const matchStr: string[] = dateStr.match(/(\d+)\/(\d+)\/(\d+) (\d+):(\d+):(\d+)/);
    return new Date(Number(matchStr[1]), Number(matchStr[2]) - 1, Number(matchStr[3]), Number(matchStr[4]), Number(matchStr[5]), Number(matchStr[6]));
  }

  /** Date型の時、分、秒を0に変換してreturn */
  setTime0InDate(date: Date): Date {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  /** '00:00'方式の時間文字列をコロンで区切り、配列で返す */
  splitTimeWithColon(time: string): number[] {
    return [Number(time.split(':')[0]), Number(time.split(':')[1])];
  }

  public static toDateString0Padding(date: Date): string {
    if (date === null || toString.call(date) !== '[object Date]') {
      return null;
    }
    const dateAlt: string = date.getFullYear() + '/'
                            + ('0' + (date.getMonth() + 1)).slice(-2) + '/'
                            + ('0' + date.getDate()).slice(-2);
    return dateAlt;
  }

  /** Date型をstring型(yyyy/MM/dd)に変換(MMが1桁なら0埋めする) */
  toDateString0Padding(date: Date): string {
    if (date === null || toString.call(date) !== '[object Date]') {
      return null;
    }
    const dateAlt: string = date.getFullYear() + '/'
                            + ('0' + (date.getMonth() + 1)).slice(-2) + '/'
                            + ('0' + date.getDate()).slice(-2);
    return dateAlt;
  }

  /** Date型をstring型(yyyyMMddHHmmssfff)に変換(0埋めする) */
  toDateStringyyyyMMddHHmmssfff(date: Date): string {
    if (date === null || toString.call(date) !== '[object Date]') {
      return null;
    }
    const dateAlt: string = date.getFullYear() +
                            ('0' + (date.getMonth() + 1)).slice(-2) +
                            ('0' + date.getDate()).slice(-2) +
                            ('0' + date.getHours()).slice(-2) +
                            ('0' + date.getMinutes()).slice(-2) +
                            ('0' + date.getMilliseconds()).slice(-3);
    return dateAlt;
  }

  /** Date型をstring型(YYYY-MM-DD hh:mm:ss)に変換(0埋めする) */
  toDateStringYYYYMMDDHHMMSS0Padding(date: Date, format_str = 'YYYY-MM-DD hh:mm:ss'): string {
    if (date === null || toString.call(date) !== '[object Date]') {
      return null;
    }
    const year_str = String(date.getFullYear());
    let month_str = String(date.getMonth() + 1);
    let day_str = String(date.getDate());
    let hour_str = String(date.getHours());
    let minute_str = String(date.getMinutes());
    let second_str = String(date.getSeconds());
    month_str = ('0' + month_str).slice(-2);
    day_str = ('0' + day_str).slice(-2);
    hour_str = ('0' + hour_str).slice(-2);
    minute_str = ('0' + minute_str).slice(-2);
    second_str = ('0' + second_str).slice(-2);

    format_str = format_str.replace(/YYYY/g, year_str);
    format_str = format_str.replace(/MM/g, month_str);
    format_str = format_str.replace(/DD/g, day_str);
    format_str = format_str.replace(/hh/g, hour_str);
    format_str = format_str.replace(/mm/g, minute_str);
    format_str = format_str.replace(/ss/g, second_str);

    return format_str;
  }

  /** 時間を4桁の文字列で返す　例：'0900' */
  to4digitsString0Padding(hours: number, min: number): string {
    if ((hours !== 0 && !hours) || (min !== 0 && !min)) {
      return null;
    }

    let str = '';
    if (hours < 10) {
      str += '0';
    }
    str += String(hours);
    if (min < 10) {
      str += '0';
    }
    str += String(min);
    return str;
  }

  public static padding0For2digits(number: number): string {
    if (number < 10) {
      return '0' + String(number);
    } else {
      return String(number);
    }
  }

  padding0For2digits(number: number): string {
    if (number < 10) {
      return '0' + String(number);
    } else {
      return String(number);
    }
  }

  getHoursByMillisec(number: number): number {
    return Math.floor(number / (60 * 60 * 1000));
  }

  getMinutesByMillisec(number: number): number {
    return Math.floor((number % (60 * 60 * 1000)) / (60 * 1000));
  }

  getTimeWithColon(hours: number, min: number): string {
    const hoursStr = this.padding0For2digits(hours);
    const minStr = this.padding0For2digits(min);
    return `${hoursStr}:${minStr}`;
  }

 public static getYYYYMMDD(date: Date): any {
    if (date === null || date === undefined) {
      return date;
    }
    const repDatYear = String(date.getFullYear());
    const repDatMonth = this.padding0For2digits(date.getMonth() + 1);
    const repDatDate = this.padding0For2digits(date.getDate());
    return `${repDatYear}/${repDatMonth}/${repDatDate}`;
  }

  getYYYYMMDD(date: Date): any {
    if (date === null || date === undefined) {
      return date;
    }
    const repDatYear = String(date.getFullYear());
    const repDatMonth = this.padding0For2digits(date.getMonth() + 1);
    const repDatDate = this.padding0For2digits(date.getDate());
    return `${repDatYear}/${repDatMonth}/${repDatDate}`;
  }

  toCSharpDateTime(date: Date): string {
    if (date === null || date === undefined) {
      return null;
    }
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
  }

  getYYYYMMDDSplitedByHyphen(date: Date): any {
    if (date === null || date === undefined) {
      return date;
    }
    const repDatYear = String(date.getFullYear());
    const repDatMonth = this.padding0For2digits(date.getMonth() + 1);
    const repDatDate = this.padding0For2digits(date.getDate());
    return `${repDatYear}-${repDatMonth}-${repDatDate}`;
  }

  getDayOfTheWeek = (date: Date, option: 'only1String' = null) => {
    if (date === null || typeof(date) !== 'object' || !(date instanceof Date)) {
      return '';
    }

    let dateT;
    if (option === 'only1String') {
      dateT = ['日', '月', '火', '水', '木', '金', '土'];
    } else {
      dateT = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];
    }
    return dateT[date.getDay()];
  }

  public static getDayOfTheWeek(date: Date, option: 'only1String' = null) {
    if (date === null || typeof(date) !== 'object' || !(date instanceof Date)) {
      return '';
    }

    let dateT;
    if (option === 'only1String') {
      dateT = ['日', '月', '火', '水', '木', '金', '土'];
    } else {
      dateT = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];
    }
    return dateT[date.getDay()];
  }

  /** Dateオブジェクト同士の差を日数(number)で返す。
   * @returns {number} 日数。引数によっては小数を返す
   */
  public getSubtractedDate(date1: Date, date2: Date): number {
    return (date2.getTime() - date1.getTime()) / 86400000;
  }

  /** 引数のDate月の月初日を返す */
  public static getFirstDayOfTheMonth(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  /** 引数のDate月の月末日を返す */
  public static getLastDayOfTheMonth(date: Date): Date {
    const d = new Date(date.getFullYear(), date.getMonth(), 1);
    d.setMonth(d.getMonth() + 1);
    d.setDate(d.getDate() - 1);
    return d;
  }
}
